import React from 'react';
import PropTypes from 'prop-types';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';

const Tooltip = (props) => {
	const {
		id,
		variant,
		trigger,
		placement,
		children,
		contentClassName,
		hide,
		flip,
		closeButtonProps,
		hideCloseButton,
		allowClick,
		allowHover,
		forceHideCounter
	} = props;

	const closeButton = hideCloseButton ? {...closeButtonProps, style: {display: 'none'}} : closeButtonProps;

	return (
		<MotifTooltip
			id={id}
			variant={variant}
			trigger={trigger}
			placement={placement}
			contentClassName={contentClassName}
			children={children}
			hide={hide}
			flip={flip}
			closeButtonProps={closeButton}
			allowClick={allowClick}
			allowHover={allowHover}
			forceHideCounter={forceHideCounter}
		/>
	);
};

export default Tooltip;

Tooltip.defaultProps = {
	id: 'tooltip',
	variant: 'default',
	trigger: null,
	placement: 'auto',
	contentClassName: '',
	children: null,
	hide: false,
	flip: true,
	closeButtonProps: null,
	hideCloseButton: false,
	allowClick: true,
	allowHover: true,
	forceHideCounter: 0
};

Tooltip.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	variant: PropTypes.oneOf(['default', 'alt']),
	trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
	placement: PropTypes.oneOf(['auto', 'top', 'right', 'bottom', 'left']),
	contentClassName: PropTypes.string,
	children: PropTypes.node,
	hide: PropTypes.bool,
	flip: PropTypes.bool,
	closeButtonProps: PropTypes.instanceOf(Object),
	hideCloseButton: PropTypes.bool,
	allowClick: PropTypes.bool,
	allowHover: PropTypes.bool,
	forceHideCounter: PropTypes.number
};
